/** Carrier portali o'ng tugma menyulari: nomzod (qaror holatiga qarab) va vakansiya (test: menu.test.ts). */
import { Check, Copy, Eye, Phone, X } from "lucide-react";
import { compactMenu, SEPARATOR, type MenuEntry } from "@/components/ui/context-menu";
import type { Translate } from "@/features/drivers/menu";

export interface PortalCandidateLike {
  full_name: string;
  status: string;
  phone: string | null;
}

export interface PortalCandidateActions {
  details: () => void;
  accept: () => void;
  reject: () => void;
  call: (phone: string) => void;
  copy: (text: string) => void;
}

/** Qaror faqat yangi yoki ko'rib chiqilayotgan nomzodga (portal paneli bilan bir xil shart) */
export function portalCandidateMenu(c: PortalCandidateLike, a: PortalCandidateActions, t: Translate): MenuEntry[] {
  const decidable = c.status === "new" || c.status === "in_review";
  return compactMenu([
    { key: "details", label: t("portal.details"), icon: Eye, onSelect: a.details },
    SEPARATOR,
    decidable && { key: "accept", label: t("portal.accept"), icon: Check, onSelect: a.accept },
    decidable && { key: "reject", label: t("portal.reject"), icon: X, onSelect: a.reject },
    SEPARATOR,
    !!c.phone && { key: "call", label: t("call"), icon: Phone, hint: c.phone ?? "", onSelect: () => a.call(c.phone as string) },
    !!c.phone && { key: "copy-phone", label: t("copyPhone"), icon: Copy, onSelect: () => a.copy(c.phone as string) },
    { key: "copy-name", label: t("copyName"), icon: Copy, onSelect: () => a.copy(c.full_name) },
  ]);
}

export function portalJobMenu(j: { title: string; pay_text: string }, copy: (text: string) => void, t: Translate): MenuEntry[] {
  return compactMenu([
    { key: "copy-title", label: t("portal.copyTitle"), icon: Copy, onSelect: () => copy(j.title) },
    !!j.pay_text && { key: "copy-pay", label: t("portal.copyPay"), icon: Copy, hint: j.pay_text, onSelect: () => copy(j.pay_text) },
  ]);
}
